import { isGoogleOrCsvSource } from '@/constants/data_sources';

/**
 * Minimal population-like shape needed to resolve feed ID.
 * Used for Google/CSV sources where the effective feed is the source's feed_id.
 */
export type PopulationForFeedId = {
  feed_id: number;
  source_id?: number;
  integration_type?: string;
};

/**
 * Resolves the actual feed ID for a population.
 * For Google/CSV sources, the feed is the source's parent feed (source.feed_id);
 * for CRM sources, it is the population's feed_id.
 * Use this whenever you need the feed for presets or sharing (e.g. getDefaultPresetId).
 *
 * @param population - Population or population-like object; may be undefined
 * @param getSourceById - Function to look up a source by id (e.g. sourcesStore.getSourceById)
 * @returns The feed ID, or undefined if population is undefined
 */
export function getFeedIdForPopulation(
  population: PopulationForFeedId | undefined,
  getSourceById: (id: number) => { feed_id?: number } | undefined,
): number | undefined {
  if (!population) return undefined;
  if (
    isGoogleOrCsvSource(population.integration_type ?? '') &&
    population.source_id
  ) {
    return getSourceById(population.source_id)?.feed_id ?? population.feed_id;
  }
  return population.feed_id;
}
